// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DashboardListEmptyState {
  display: flex;
  flex-direction: row;
  justify-content: center;
  width: 100%;
  column-gap: 32px;
  min-width: 700px;
}
.DashboardListEmptyState .textContent {
  display: flex;
  flex-direction: column;
  row-gap: 16px;
}
.DashboardListEmptyState .textContent p {
  font-size: 24px;
  color: var(--color_neutral_900);
  font-weight: 600;
}
.DashboardListEmptyState .textContent span {
  font-size: 14px;
  color: var(--color_neutral_800);
  font-weight: 400;
}`, "",{"version":3,"sources":["webpack://./src/modules/dashboard/dashboard-list-empty-state/dashboard-list-empty-state.styles.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,gBAAA;EACA,gBAAA;AACF;AACE;EACE,aAAA;EACA,sBAAA;EACA,aAAA;AACJ;AACI;EACE,eAAA;EACA,+BAAA;EACA,gBAAA;AACN;AAEI;EACE,eAAA;EACA,+BAAA;EACA,gBAAA;AAAN","sourcesContent":[".DashboardListEmptyState {\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  width: 100%;\n  column-gap: 32px;\n  min-width: 700px;\n\n  .textContent {\n    display: flex;\n    flex-direction: column;\n    row-gap: 16px;\n\n    p {\n      font-size: 24px;\n      color: var(--color_neutral_900);\n      font-weight: 600;\n    }\n\n    span {\n      font-size: 14px;\n      color: var(--color_neutral_800);\n      font-weight: 400;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
